import script from "./ModalRestoration.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalRestoration.vue?vue&type=script&setup=true&lang=js"

import "./ModalRestoration.vue?vue&type=style&index=0&id=1f1961c6&lang=css"

const __exports__ = script;

export default __exports__